import CloseIcon from '../../assets/images/closeIcon.svg';

const ClearButton = ({ onClick }) => {
  return <img src={CloseIcon} onClick={onClick} alt={'clear'} />;
};

export default ClearButton;
